'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { fromJS } from 'immutable';
import ActionTypes from '../constants/ActionTypes';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import installStatusModal from './installStatusModal';
import purchasedGood from './purchasedGood';
import refundModal from './refundModal';
import uninstallConfirmModal from './uninstallConfirmModal';
import uninstallModal from './uninstallModal';
import RowDeliveryState from '../constants/RowDeliveryState';
var initialState = fromJS({
  checkGoodUsageStatus: RequestStatusTypes.UNINITIALIZED,
  checkGoodUsageErrorIds: {},
  createAssetError: null,
  createAssetStatus: RequestStatusTypes.UNINITIALIZED,
  createWebpageModalOpen: false,
  createNewAssetModal: {
    good: {},
    open: false
  },
  errorReinstallingGood: false,
  fetchRequestStatus: RequestStatusTypes.UNINITIALIZED,
  installStatusModal: {
    goodId: '',
    open: false
  },
  pollingGoodId: '',
  pollingGoodStatus: RequestStatusTypes.UNINITIALIZED,
  paypalPurchaseDelay: false,
  purchaseActionsMenuGoodId: '',
  purchaseDetailsGoodId: '',
  purchasedGoodsDisplayOrder: [],
  purchasedGoodsTotal: 0,
  purchasedGoods: {},
  redeliveringGood: false,
  refundModal: refundModal(undefined, {}),
  uninstallConfirmModal: uninstallConfirmModal(undefined, {}),
  uninstallModal: {
    modalType: '',
    goodName: '',
    goodSubtype: '',
    open: false,
    assetsWhereGoodInUse: [],
    packChildrenInUse: []
  }
});

function getPurchasedGoodsWithUpdatedPathsForNewlyPurchasedChildTemplates(newlyPurchasedGood, purchasedGoods, action) {
  return purchasedGoods.map(function (pg) {
    if (pg.get('parentId') === newlyPurchasedGood.get('goodId')) {
      return purchasedGood(pg, action);
    }

    return pg;
  });
}

export default function managePurchasesReducer() {
  var managePurchases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.PURCHASE_DETAILS_CLOSED:
      return managePurchases.set('purchaseDetailsGoodId', '');

    case ActionTypes.PURCHASE_DETAILS_OPENED:
      return managePurchases.set('purchaseDetailsGoodId', action.payload.purchasedGoodsKey);

    case ActionTypes.PURCHASE_ACTIONS_MENU_CLOSED:
      return managePurchases.set('purchaseActionsMenuGoodId', '');

    case ActionTypes.PURCHASE_ACTIONS_MENU_OPENED:
      return managePurchases.set('purchaseActionsMenuGoodId', action.payload.purchasedGoodsKey);

    case ActionTypes.SHOW_UNINSTALL_CONFIRM_MODAL:
      return managePurchases.merge({
        uninstallConfirmModal: uninstallConfirmModal(managePurchases.get('uninstallConfirmModal'), action),
        checkGoodUsageStatus: RequestStatusTypes.UNINITIALIZED
      });

    case ActionTypes.DISMISSED_UNINSTALL_CONFIRM_MODAL:
    case ActionTypes.UNINSTALL_GOOD:
      return managePurchases.set('uninstallConfirmModal', uninstallConfirmModal(managePurchases.get('uninstallConfirmModal'), action));

    case ActionTypes.SHOW_UNINSTALL_MODAL:
      return managePurchases.merge({
        uninstallModal: uninstallModal(managePurchases.get('uninstallModal'), action),
        checkGoodUsageStatus: RequestStatusTypes.UNINITIALIZED
      });

    case ActionTypes.DISMISSED_UNINSTALL_MODAL:
      return managePurchases.set('uninstallModal', uninstallModal(managePurchases.get('uninstallModal'), action));

    case ActionTypes.REFUND_MODAL_OPENED:
      return managePurchases.merge({
        refundModal: refundModal(managePurchases.get('refundModal'), action),
        checkGoodUsageStatus: RequestStatusTypes.UNINITIALIZED
      });

    case ActionTypes.DISMISSED_REFUND_MODAL:
    case ActionTypes.REFUND_SUBMITTED:
    case ActionTypes.REFUND_SUBMITTED_SUCCESS:
      return managePurchases.set('refundModal', refundModal(managePurchases.get('refundModal'), action));

    case ActionTypes.REFUND_UPDATE_SUCCESS:
      {
        var goodIdToUpdate = managePurchases.get('purchaseDetailsGoodId') || action.payload.goodId;
        return managePurchases.mergeIn(['purchasedGoods', goodIdToUpdate, 'refund'], action.payload.refund);
      }

    case ActionTypes.REFUND_CANCEL_SUCCESS:
      {
        var _goodIdToUpdate = managePurchases.get('purchaseDetailsGoodId') || action.payload;

        return managePurchases.mergeIn(['purchasedGoods', _goodIdToUpdate, 'deliveryStatus'], RowDeliveryState.UNINSTALLED);
      }

    case ActionTypes.PURCHASED_GOODS_RECEIVED:
      return managePurchases.merge({
        fetchRequestStatus: RequestStatusTypes.SUCCEEDED,
        purchasedGoodsDisplayOrder: action.payload.purchasedGoodsDisplayOrder,
        purchasedGoodsTotal: action.payload.purchasedGoodsTotal,
        purchasedGoods: action.payload.purchasedGoods,
        uninstallConfirmModal: uninstallConfirmModal(managePurchases.get('uninstallConfirmModal'), action)
      });

    case ActionTypes.TOGGLE_PURCHASED_PACK:
      return managePurchases.setIn(['purchasedGoods', action.payload.goodId], purchasedGood(managePurchases.getIn(['purchasedGoods', action.payload.goodId]), action));

    case ActionTypes.GOOD_USAGE_INFO_RECEIVED:
    case ActionTypes.REVIEW_SUBMITTED_FROM_PURCHASES_SUCCESS:
      return managePurchases.setIn(['purchasedGoods', action.payload.purchasedGoodsKey], purchasedGood(managePurchases.getIn(['purchasedGoods', action.payload.purchasedGoodsKey]), action));

    case ActionTypes.CHECK_GOOD_USAGE_ERROR_ALERT_DISMISSED:
      {
        var errorId = action.payload.errorId;
        var checkGoodUsageErrorIds = managePurchases.get('checkGoodUsageErrorIds');
        var updatedCheckGoodUsageErrorIds = errorId ? checkGoodUsageErrorIds.delete(errorId) : checkGoodUsageErrorIds.clear();
        return managePurchases.merge({
          checkGoodUsageStatus: updatedCheckGoodUsageErrorIds.size ? RequestStatusTypes.FAILED : RequestStatusTypes.UNINITIALIZED,
          checkGoodUsageErrorIds: updatedCheckGoodUsageErrorIds
        });
      }

    case ActionTypes.CHECK_GOOD_USAGE:
      if (action.error) {
        var _errorId = action.payload.errorId;
        return managePurchases.mergeDeep({
          checkGoodUsageStatus: RequestStatusTypes.FAILED,
          checkGoodUsageErrorIds: _defineProperty({}, _errorId, true)
        });
      }

      return managePurchases.set('checkGoodUsageStatus', RequestStatusTypes.PENDING);

    case ActionTypes.CREATE_ASSET:
      return managePurchases.merge({
        createAssetError: action.error ? action.payload.error : null,
        createAssetStatus: action.error ? RequestStatusTypes.FAILED : RequestStatusTypes.PENDING
      });

    case ActionTypes.PURCHASED_GOODS_REQUESTED:
      if (action.error) {
        return managePurchases.set('fetchRequestStatus', RequestStatusTypes.FAILED);
      }

      return managePurchases.set('fetchRequestStatus', RequestStatusTypes.PENDING);

    case ActionTypes.PURCHASED_WITH_STRIPE:
      if (!action.error) {
        return managePurchases.set('pollingGoodId', action.payload);
      }

      return managePurchases;

    case ActionTypes.PAYPAL_PURCHASE_COMPLETED:
      return managePurchases.merge({
        pollingGoodId: action.payload.goodId
      });

    case ActionTypes.REDELIVERING_GOOD:
      return managePurchases.merge({
        pollingGoodId: action.payload.goodId,
        redeliveringGood: true
      });

    case ActionTypes.POLLING_GOOD_INFO_RECEIVED:
      {
        var managePurchasesWithUpdatedPollingGoodStatus = managePurchases.merge({
          pollingGoodId: action.payload.goodId,
          pollingGoodStatus: action.payload.goodStatus
        });

        if (action.payload.goodStatus === RequestStatusTypes.SUCCEEDED) {
          var newlyPurchasedGood = managePurchasesWithUpdatedPollingGoodStatus.getIn(['purchasedGoods', action.payload.goodId.toString()]);

          if (!newlyPurchasedGood) {
            return managePurchases.set('paypalPurchaseDelay', true);
          }

          if (newlyPurchasedGood.get('totalChildren')) {
            return managePurchasesWithUpdatedPollingGoodStatus.set('redeliveringGood', false).set('purchasedGoods', getPurchasedGoodsWithUpdatedPathsForNewlyPurchasedChildTemplates(newlyPurchasedGood, managePurchasesWithUpdatedPollingGoodStatus.get('purchasedGoods'), action));
          }

          return managePurchasesWithUpdatedPollingGoodStatus.set('redeliveringGood', false).setIn(['purchasedGoods', action.payload.goodId.toString()], purchasedGood(newlyPurchasedGood, action));
        }

        return managePurchasesWithUpdatedPollingGoodStatus;
      }

    case ActionTypes.OPEN_SLOW_DELIVERY_MODAL:
    case ActionTypes.DISMISSED_INSTALL_STATUS_MODAL:
      return managePurchases.set('installStatusModal', installStatusModal(managePurchases.get('installStatusModal'), action));

    case ActionTypes.ERROR_REINSTALLING_GOOD:
      return managePurchases.set('errorReinstallingGood', true);

    case ActionTypes.PAYPAL_DELAY_ERROR_ALERT_DISMISSED:
      return managePurchases.set('paypalPurchaseDelay', false);

    case ActionTypes.DISMISSED_REINSTALLATION_ERROR_ALERT:
      return managePurchases.set('errorReinstallingGood', false);

    case ActionTypes.CREATE_WEBPAGE_MODAL_OPENED:
      return managePurchases.set('createWebpageModalOpen', true);

    case ActionTypes.CREATE_WEBPAGE_MODAL_DISMISSED:
      return managePurchases.set('createWebpageModalOpen', false);

    case ActionTypes.CREATE_NEW_ASSET_MODAL_OPENED:
      return managePurchases.set('createNewAssetModal', {
        open: true,
        good: action.payload.good
      });

    case ActionTypes.CREATE_NEW_ASSET_MODAL_DISMISSED:
      return managePurchases.merge({
        createAssetError: null,
        createAssetStatus: RequestStatusTypes.UNINITIALIZED,
        createNewAssetModal: {
          open: false,
          good: {}
        }
      });

    default:
      return managePurchases;
  }
}